import style from './Rodape.module.css'

function Rodape() {
    return (
        <footer className={style.rodape}>
            <h2>
                Desenvolvido por Regis.
            </h2>
        </footer>

    )
}

export default Rodape;